import { create } from 'zustand';

export interface NotificationAction {
  label: string;
  onAction: () => void;
}

export interface Notification {
  id: string;
  kind: string;
  severity: 'info' | 'notice' | 'negative' | 'positive';
  title: string;
  description?: string;
  action?: NotificationAction;
  read: boolean;
  dismissible: boolean;
  createdAt: number;
}

interface NotificationsState {
  list: Notification[];
  upsert: (n: Notification) => void;
  markRead: (id: string) => void;
  markAllRead: () => void;
  dismiss: (id: string) => void;
}

export const useNotificationsStore = create<NotificationsState>((set) => ({
  list: [],
  upsert: (n) =>
    set((s) => {
      const idx = s.list.findIndex((x) => x.id === n.id);
      if (idx >= 0) {
        const next = [...s.list];
        next[idx] = { ...next[idx], ...n };
        return { list: next };
      }
      return { list: [...s.list, n] };
    }),
  markRead: (id) =>
    set((s) => ({ list: s.list.map((n) => (n.id === id ? { ...n, read: true } : n)) })),
  markAllRead: () => set((s) => ({ list: s.list.map((n) => ({ ...n, read: true })) })),
  dismiss: (id) => set((s) => ({ list: s.list.filter((n) => n.id !== id) })),
}));
